<template>
  <section class="events bh-section">
    <div class="bh-container">
      <div v-reveal>
        <h2 class="bh-section__title">Upcoming events</h2>
        <p class="bh-section__lead">
          The 13th annual banquet is February 27, 2027. The venue will be announced here.
        </p>
      </div>

      <div class="events__list">
        <article
          v-for="(event, index) in upcoming"
          :key="event.title"
          v-reveal="{ delay: index * 120 }"
          class="event-card"
        >
          <p class="event-card__eyebrow">{{ event.eyebrow }}</p>
          <h3 class="event-card__title">{{ event.title }}</h3>
          <dl class="event-card__meta">
            <div v-for="meta in event.meta" :key="meta.label">
              <dt>{{ meta.label }}</dt>
              <dd>
                <template v-for="(line, i) in meta.lines" :key="i">
                  {{ line }}<br v-if="i < meta.lines.length - 1" />
                </template>
              </dd>
            </div>
          </dl>
          <p class="event-card__copy">{{ event.copy }}</p>
          <p v-if="event.comingSoon" class="event-card__soon">Coming Soon</p>
          <a
            v-else-if="event.externalHref"
            class="bh-btn bh-btn--primary"
            :href="event.externalHref"
            target="_blank"
            rel="noopener noreferrer"
          >
            {{ event.ctaLabel }}
          </a>
          <router-link v-else-if="event.to" class="bh-btn bh-btn--secondary" :to="event.to">
            {{ event.ctaLabel }}
          </router-link>
        </article>
      </div>

      <router-link v-if="!showPast" class="past-link" to="/events">
        Past events and photos
      </router-link>

      <div v-if="showPast" class="past">
        <h3 v-reveal class="gallery__title">Past events</h3>
        <div class="events__list">
          <article
            v-for="(event, index) in past"
            :key="event.title"
            v-reveal="{ delay: index * 120 }"
            class="event-card event-card--past"
          >
            <p class="event-card__eyebrow">{{ event.eyebrow }}</p>
            <h3 class="event-card__title">{{ event.title }}</h3>
            <dl class="event-card__meta">
              <div v-for="meta in event.meta" :key="meta.label">
                <dt>{{ meta.label }}</dt>
                <dd>
                  <template v-for="(line, i) in meta.lines" :key="i">
                    {{ line }}<br v-if="i < meta.lines.length - 1" />
                  </template>
                </dd>
              </div>
            </dl>
            <p class="event-card__copy">{{ event.copy }}</p>
            <router-link v-if="event.to" class="bh-btn bh-btn--secondary" :to="event.to">
              {{ event.ctaLabel }}
            </router-link>
          </article>
        </div>
      </div>

      <div v-if="showPast" class="gallery">
        <h3 v-reveal class="gallery__title">2026 banquet</h3>
        <div class="gallery__grid">
          <img
            v-for="(src, index) in gallery2026"
            :key="src"
            v-reveal="{ variant: 'scale', delay: (index % 4) * 80 }"
            :src="src"
            :alt="'2026 banquet photo ' + (index + 1)"
            class="gallery__image"
            loading="lazy"
          />
        </div>
      </div>

      <div v-if="showPast" class="gallery">
        <h3 v-reveal class="gallery__title">2025 banquet</h3>
        <div class="gallery__grid">
          <img
            v-for="(src, index) in gallery2025"
            :key="src"
            v-reveal="{ variant: 'scale', delay: (index % 4) * 80 }"
            :src="src"
            :alt="'2025 banquet photo ' + (index + 1)"
            class="gallery__image"
            loading="lazy"
          />
        </div>
      </div>
    </div>
  </section>
</template>

<script>
const UPCOMING = [
  {
    eyebrow: "Banquet",
    title: "13th Annual Lion Hunters Banquet — Cougar Classic",
    meta: [
      { label: "Date", lines: ["February 27, 2027"] },
      { label: "Location", lines: ["Venue to be announced"] },
    ],
    copy: "Cougar Classic 2027.",
    comingSoon: true,
  },
  {
    eyebrow: "Contest",
    title: "Second Annual Big Cat Contest",
    meta: [
      { label: "Season", lines: ["Next Black Hills Fire Protection District season"] },
      { label: "Details", lines: ["Registration link coming"] },
    ],
    copy: "Biggest male and biggest female.",
    comingSoon: true,
  },
];

const PAST = [
  {
    eyebrow: "Banquet",
    title: "12th Annual Lion Hunters Banquet",
    meta: [
      { label: "Date", lines: ["February 28, 2026", "Doors at 5:00 PM"] },
      {
        label: "Location",
        lines: [
          "Diamond Spur Event Center at Three Forks",
          "23826 Mill Iron Dr, Rapid City, SD",
        ],
      },
    ],
    copy: "Cougar Classic. Pre-registration for this banquet is closed.",
  },
  {
    eyebrow: "Contest",
    title: "First Annual Big Cat Contest",
    meta: [
      { label: "Season", lines: ["2026 Black Hills Fire Protection District season"] },
    ],
    copy: "The first contest is complete. The second annual contest is listed above.",
    ctaLabel: "Contest page",
    to: "/BigCatContest",
  },
];

export default {
  name: "UpcomingEvents",
  data() {
    return {
      upcoming: UPCOMING,
      past: PAST,
      gallery2026: [
        require("@/assets/2026 banquet/20260228_202114.jpg"),
        require("@/assets/2026 banquet/20260228_202349.jpg"),
        require("@/assets/2026 banquet/20260228_202855.jpg"),
        require("@/assets/2026 banquet/20260228_203012.jpg"),
        require("@/assets/2026 banquet/20260228_203037.jpg"),
        require("@/assets/2026 banquet/20260228_203727.jpg"),
        require("@/assets/2026 banquet/20260228_203814.jpg"),
        require("@/assets/2026 banquet/20260228_210113.jpg"),
        require("@/assets/2026 banquet/20260228_211141.jpg"),
        require("@/assets/2026 banquet/img_0069.jpg"),
        require("@/assets/2026 banquet/img_0070.jpg"),
        require("@/assets/2026 banquet/img_0071.jpg"),
        require("@/assets/2026 banquet/img_0072.jpg"),
        require("@/assets/2026 banquet/img_0073.jpg"),
        require("@/assets/2026 banquet/img_0074.jpg"),
        require("@/assets/2026 banquet/img_0075.jpg"),
        require("@/assets/2026 banquet/img_0076.jpg"),
        require("@/assets/2026 banquet/img_0077.jpg"),
        require("@/assets/2026 banquet/img_0078.jpg"),
        require("@/assets/2026 banquet/img_0079.jpg"),
        require("@/assets/2026 banquet/img_0080.jpg"),
      ],
      gallery2025: [
        require("@/assets/2025 banquet/474923330_1305398290724533_5892846435599674932_n.jpg"),
        require("@/assets/2025 banquet/475485442_2863168723887696_6919459045794420050_n.jpg"),
        require("@/assets/2025 banquet/475648887_1872280010174934_6106697229316298159_n.jpg"),
        require("@/assets/2025 banquet/475871212_1161527798973728_7161666939610600217_n.jpg"),
        require("@/assets/2025 banquet/475923808_1780874402766561_1346193012891182818_n.jpg"),
        require("@/assets/2025 banquet/475929277_494223413417707_7740662963516553082_n.jpg"),
        require("@/assets/2025 banquet/476120654_4068240750076629_4332679045472467357_n.jpg"),
        require("@/assets/2025 banquet/476331709_994927792575079_7436205314207765259_n.jpg"),
      ],
    };
  },
  computed: {
    showPast() {
      return this.$route.path === "/events";
    },
  },
};
</script>

<style scoped>
.events {
  background: var(--bh-stone);
  text-align: center;
}

.events__list {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 1.5rem;
  text-align: left;
  margin: 2rem 0 1.5rem;
}

.event-card {
  background: var(--bh-surface);
  border: 1px solid var(--bh-border);
  border-left: 4px solid var(--bh-forest);
  border-radius: var(--bh-radius);
  box-shadow: var(--bh-shadow);
  padding: 1.75rem;
  transition: transform 0.25s ease, box-shadow 0.25s ease;
}

.event-card--past {
  border-left-color: var(--bh-border);
  box-shadow: none;
}

.event-card.is-visible:hover {
  transform: translateY(-4px);
  box-shadow: 0 8px 28px rgba(26, 31, 28, 0.1);
}

.event-card__eyebrow {
  margin: 0 0 0.5rem;
  font-size: 0.75rem;
  font-weight: 600;
  letter-spacing: 0.08em;
  text-transform: uppercase;
  color: var(--bh-amber);
}

.event-card__title {
  font-family: var(--bh-font-display);
  font-size: 1.35rem;
  font-weight: 600;
  line-height: 1.25;
  color: var(--bh-forest);
  margin: 0 0 1rem;
}

.event-card__meta {
  display: grid;
  gap: 0.75rem;
  margin: 0 0 1rem;
}

.event-card__meta dt {
  font-size: 0.75rem;
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 0.05em;
  color: var(--bh-muted);
}

.event-card__meta dd {
  margin: 0.15rem 0 0;
  color: var(--bh-ink);
  line-height: 1.45;
}

.event-card__copy {
  color: var(--bh-muted);
  line-height: 1.55;
  margin: 0 0 1.25rem;
}

.event-card__soon {
  display: inline-block;
  margin: 0;
  padding: 0.35rem 0.75rem;
  border-radius: 999px;
  background: rgba(193, 122, 47, 0.12);
  color: var(--bh-amber-hover);
  font-size: 0.9rem;
  font-weight: 600;
}

.past-link {
  display: inline-block;
  margin-bottom: 0.5rem;
  color: var(--bh-forest);
  font-weight: 600;
}

.past {
  margin-top: 2.5rem;
  text-align: left;
}

.gallery {
  margin-top: 2.5rem;
  text-align: left;
}

.gallery__title {
  font-family: var(--bh-font-display);
  font-size: 1.35rem;
  font-weight: 600;
  color: var(--bh-forest);
  margin: 0 0 1.25rem;
  text-align: left;
}

.gallery__grid {
  display: grid;
  grid-template-columns: repeat(4, minmax(0, 1fr));
  gap: 0.85rem;
}

.gallery__image {
  width: 100%;
  aspect-ratio: 1;
  object-fit: cover;
  border-radius: var(--bh-radius);
  border: 1px solid var(--bh-border);
}

@media (max-width: 960px) {
  .events__list {
    grid-template-columns: 1fr;
  }

  .gallery__grid {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }
}
</style>
